"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_tpa_dto_1 = require("./dto/create-tpa.dto");
const get_tpas_query_dto_1 = require("./dto/get-tpas-query.dto");
const update_tpa_dto_1 = require("./dto/update-tpa.dto");
const tpa_service_1 = require("./tpa.service");
const tpa_swagger_1 = require("./tpa.swagger");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let TpaController = class TpaController {
    constructor(tpaService, scopeService) {
        this.tpaService = tpaService;
        this.scopeService = scopeService;
    }
    /**
     * Creates a new TPA record by delegating the service
     */
    async addTpa(createTpaObject, res, req) {
        const userId = parseInt(req?.headers?.userid);
        try {
            const tpa = await this.tpaService.addTpa(createTpaObject, userId);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.tpaCreated, tpa));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.infoMessages.tpaNotFound, messages_1.infoMessages.forBidden, messages_1.infoMessages.unknownError);
        }
    }
    /**
     * Retrieves all the records of the TPA by delegating the service
     */
    async getTpas(queries, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const tpas = await this.tpaService.getTpas(userId, queries.sort || "createdAt:DESC", queries.page || constants_1.TPA_DEFAULT_PAGE, queries.limit || constants_1.TPA_DEFAULT_PAGE_LIMIT, queries.search, queries.searchBy);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.tpasRetrieved, tpas));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.infoMessages.tpaNotFound, messages_1.infoMessages.forBidden, messages_1.infoMessages.unknownError);
        }
    }
    /**
     * Retrieves the list of companies by delegating the service
     */
    async getCompanyList(query, res, req) {
        try {
            const { page, limit, search, sortBy, sort } = query;
            const userId = parseInt(req?.headers?.userid);
            const insurerCompanyList = await this.tpaService.getCompanyList(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", sortBy || constants_1.COMPANY_DISPLAY_NAME, sort || constants_1.DEFAULT_ASC_SORT_ORDER, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.tpaCompanyListRetrieved, insurerCompanyList));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error.message || messages_1.errorMessages.tpaCompanyListNotFound));
        }
    }
    /**
     * Retrieves the basic details of a company by delegating the service
     */
    async getCompanyBasicDetails(id, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const companyData = await this.tpaService.getCompanyBasicDetails(parseInt(id), userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.tpaDetailsRetrieved, companyData);
        }
        catch (error) {
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error instanceof Error ? error.message : messages_1.errorMessages.companyNotFound);
        }
    }
    /**
     * Retrieves a TPA record by tpaId by delegating the service
     */
    async getTpaById(tpaId, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, 'Tpa', 'view', tpaId);
            if (!viewValidation) {
                return res
                    .status(common_1.HttpStatus.FORBIDDEN)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to view this company."));
            }
            const editValidation = await this.scopeService.validateResourceScope(userId, 'Tpa', 'edit', tpaId);
            const tpa = await this.tpaService.getTpaById(+tpaId);
            const responseData = { ...tpa, editable: editValidation };
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.tpaRetrieved, responseData));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.infoMessages.tpaNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.unknownError);
        }
    }
    /**
     * Retrives the TPA record by tpaId and updates the TPA record
     */
    async updateTpaById(tpaId, updateTpaObject, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, 'Tpa', 'edit', tpaId);
            if (!editValidation) {
                return res
                    .status(common_1.HttpStatus.FORBIDDEN)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            const tpa = await this.tpaService.updateTpaById(+tpaId, updateTpaObject, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.tpaUpdated, tpa));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.infoMessages.tpaNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.unknownError);
        }
    }
    /**
     * Deletes the TPA record by tpaId by delegating the service
     */
    async deleteTpaById(tpaId, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, 'Tpa', 'edit', tpaId);
            if (!editValidation) {
                return res
                    .status(common_1.HttpStatus.FORBIDDEN)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            await this.tpaService.deleteTpaById(+tpaId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.tpaDeleted));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.infoMessages.tpaNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.unknownError);
        }
    }
    /** Get contacts of a TPA by ID. */
    async getTpaContacts(tpaId, res) {
        try {
            const contacts = await this.tpaService.getTpaContacts(tpaId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.tpaContactsRetrieved, contacts));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message || messages_1.errorMessages.tpaContactsNotFound));
            }
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error.message || messages_1.errorMessages.failedToFetchTpaContacts));
        }
    }
};
exports.TpaController = TpaController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, tpa_swagger_1.addTpaSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof create_tpa_dto_1.CreateTpaDto !== "undefined" && create_tpa_dto_1.CreateTpaDto) === "function" ? _c : Object, Object, typeof (_d = typeof Request !== "undefined" && Request) === "function" ? _d : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "addTpa", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, tpa_swagger_1.getTpasSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_e = typeof get_tpas_query_dto_1.GetTpasDto !== "undefined" && get_tpas_query_dto_1.GetTpasDto) === "function" ? _e : Object, Object, typeof (_f = typeof Request !== "undefined" && Request) === "function" ? _f : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "getTpas", null);
tslib_1.__decorate([
    (0, common_1.Get)("tpaList"),
    (0, tpa_swagger_1.getCompanyListSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, typeof (_g = typeof Request !== "undefined" && Request) === "function" ? _g : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "getCompanyList", null);
tslib_1.__decorate([
    (0, common_1.Get)("details/:id"),
    (0, tpa_swagger_1.getCompanyDetailsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_h = typeof Request !== "undefined" && Request) === "function" ? _h : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "getCompanyBasicDetails", null);
tslib_1.__decorate([
    (0, common_1.Get)(":tpaId"),
    (0, tpa_swagger_1.getTpaByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("tpaId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_j = typeof Request !== "undefined" && Request) === "function" ? _j : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "getTpaById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":tpaId"),
    (0, tpa_swagger_1.updateTpaByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("tpaId")),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_k = typeof update_tpa_dto_1.UpdateTpaDto !== "undefined" && update_tpa_dto_1.UpdateTpaDto) === "function" ? _k : Object, Object, typeof (_l = typeof Request !== "undefined" && Request) === "function" ? _l : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "updateTpaById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":tpaId"),
    (0, tpa_swagger_1.deleteTpaByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("tpaId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_m = typeof Request !== "undefined" && Request) === "function" ? _m : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "deleteTpaById", null);
tslib_1.__decorate([
    (0, common_1.Get)(":tpaId/contacts"),
    (0, tpa_swagger_1.getTpaContactsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("tpaId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TpaController.prototype, "getTpaContacts", null);
exports.TpaController = TpaController = tslib_1.__decorate([
    (0, common_1.Controller)("tpa"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof tpa_service_1.TpaService !== "undefined" && tpa_service_1.TpaService) === "function" ? _a : Object, typeof (_b = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _b : Object])
], TpaController);
